module.exports = __webpack_public_path__ + "files/78eb9d06e4678e41478c69bd1c755a04.png";